<script>
import Head from '@/components/Head';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Select from '@/components/Select';
import Loader from '@/components/Loader';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
    data() {
        return {
            loader: false,
            selectedReport: '',
            reportTypes: [
                { name: 'Selecione um tipo de relatório', value: '' },
                { name: 'Associados Adimplentes', value: 'adimplentes' },
                { name: 'Associados Inadimplentes', value: 'inadimplentes' },
                { name: 'Associados Excluídos', value: 'excluidos' },
                { name: 'Associados Falecidos', value: 'falecidos' },
                { name: 'Relatório de Bonificações/Descontos', value: 'bonificacoes' },
                { name: 'Pagamentos por Período', value: 'pagamentos-periodo' },
                { name: 'Status Financeiro Geral', value: 'status-geral' },
                { name: 'Débitos Anteriores', value: 'debitos-anteriores' },
                { name: 'Associados Ativos', value: 'ativos' },
                { name: 'Associados Inativos (Excluídos + Falecidos)', value: 'inativos' },
                { name: 'Fluxo de Caixa por Período', value: 'fluxo-caixa' },
                { name: 'Parcelas Vencidas', value: 'parcelas-vencidas' },
            ],
            filters: {
                initial_date: '',
                finish_date: '',
                payment_type: '',
                financial_situation: '',
                registration_status: '',
                min_value: '',
                max_value: '',
            },
            paymentTypeOptions: [
                { name: 'Todos', value: '' },
                { name: 'Mensalidade', value: 'Mensalidade' },
                { name: 'Semestralidade', value: 'Semestralidade' },
                { name: 'Anuidade', value: 'Anuidade' },
            ],
            financialSituationOptions: [
                { name: 'Todos', value: '' },
                { name: 'Adimplente', value: 'Adimplente' },
                { name: 'Inadimplente', value: 'Inadimplente' },
            ],
            registrationStatusOptions: [
                { name: 'Todos', value: '' },
                { name: 'Ativo', value: 'Ativo' },
                { name: 'Inativo', value: 'Inativo' },
                { name: 'Excluído', value: 'Excluído' },
            ],
            reportData: null,
            showPreview: false,
        }
    },
    props: {
        userData: {
            type: Object
        }
    },
    created() {
        if (this.userData.role === 'associate') {
            this.$router.push('/inicio');
        }
        
        // Data padrão: último mês
        const today = new Date();
        const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        this.filters.initial_date = lastMonth.toISOString().split('T')[0];
        this.filters.finish_date = today.toISOString().split('T')[0];
    },
    methods: {
        notify(text, type) {
            toast(text, {
                "type": type == 'info' ? 'info' : type == 'warning' ? 'warning' : type == 'error' ? 'error' : type == 'success' ? 'success' : 'default',
            });
        },

        generateReport() {
            if (!this.selectedReport) {
                return this.notify('Selecione um tipo de relatório!', 'warning');
            }

            this.loader = true;

            const endpoint = this.getReportEndpoint();
            const params = this.buildParams();

            this.$axios.get(endpoint, { params })
            .then(res => {
                this.reportData = res.data.data;
                this.showPreview = true;
                this.loader = false;
                this.notify('Relatório gerado com sucesso!', 'success');
            })
            .catch(err => {
                this.notify(err.response?.data?.message || 'Erro ao gerar relatório!', 'error');
                this.loader = false;
            });
        },

        getReportEndpoint() {
            const endpoints = {
                'adimplentes': '/reports/adimplentes',
                'inadimplentes': '/reports/inadimplentes',
                'excluidos': '/reports/cancelados',
                'falecidos': '/reports/falecidos',
                'bonificacoes': '/reports/bonificacoes',
                'pagamentos-periodo': '/reports/pagamentos-periodo',
                'status-geral': '/reports/status-geral',
                'debitos-anteriores': '/reports/debitos-anteriores',
                'ativos': '/reports/ativos',
                'inativos': '/reports/inativos',
                'fluxo-caixa': '/reports/fluxo-caixa',
                'parcelas-vencidas': '/reports/parcelas-vencidas',
            };
            return endpoints[this.selectedReport] || '/reports/status-geral';
        },

        buildParams() {
            const params = {};
            // Excluídos/falecidos: listar todos do status (sem cortar pelo período padrão do formulário)
            const reportsWithoutDefaultDateFilter = ['excluidos', 'falecidos', 'inativos'];
            if (!reportsWithoutDefaultDateFilter.includes(this.selectedReport)) {
                if (this.filters.initial_date) params.initial_date = this.filters.initial_date;
                if (this.filters.finish_date) params.finish_date = this.filters.finish_date;
            }
            if (this.filters.payment_type) params.payment_type = this.filters.payment_type;
            if (this.filters.financial_situation) params.financial_situation = this.filters.financial_situation;
            if (this.filters.registration_status) params.registration_status = this.filters.registration_status;
            if (this.filters.min_value) params.min_value = this.filters.min_value;
            if (this.filters.max_value) params.max_value = this.filters.max_value;
            return params;
        },

        exportPDF() {
            if (!this.reportData) {
                return this.notify('Gere um relatório primeiro!', 'warning');
            }

            const doc = new jsPDF('landscape');
            const reportTitle = this.getReportTitle();
            
            // Header
            doc.setFontSize(18);
            doc.text(reportTitle, 14, 20);
            
            doc.setFontSize(11);
            doc.text(`ANIPP - Associação Nacional e Independente de Participantes do Postalis`, 14, 28);
            doc.text(`Data de Geração: ${new Date().toLocaleDateString('pt-BR')}`, 14, 34);
            
            if (this.filters.initial_date && this.filters.finish_date) {
                doc.text(`Período: ${this.formatDate(this.filters.initial_date)} a ${this.formatDate(this.filters.finish_date)}`, 14, 40);
            }

            // Table
            const tableData = this.formatTableDataForPDF();
            
            autoTable(doc, {
                head: [tableData.headers],
                body: tableData.rows,
                startY: this.filters.initial_date && this.filters.finish_date ? 45 : 40,
                theme: 'grid',
                headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' },
                styles: { fontSize: 8, cellPadding: 2 },
                alternateRowStyles: { fillColor: [245, 245, 245] },
            });

            // Footer com totais se houver
            if (this.reportData.summary) {
                const finalY = doc.lastAutoTable.finalY || 45;
                doc.setFontSize(10);
                doc.setFont(undefined, 'bold');
                doc.text('RESUMO:', 14, finalY + 10);
                doc.setFont(undefined, 'normal');
                
                let summaryY = finalY + 16;
                Object.entries(this.reportData.summary).forEach(([key, value]) => {
                    doc.text(`${key}: ${value}`, 14, summaryY);
                    summaryY += 6;
                });
            }

            const fileName = `${this.selectedReport}_${new Date().toISOString().split('T')[0]}.pdf`;
            doc.save(fileName);
            this.notify('PDF exportado com sucesso!', 'success');
        },

        formatTableDataForPDF() {
            const reportType = this.selectedReport;
            let headers = [];
            let rows = [];

            switch(reportType) {
                case 'inadimplentes':
                    headers = ['Nome', 'CPF', 'Status Financeiro', 'Matrícula', 'Valor'];
                    rows = (this.reportData.associados || []).map(a => [
                        a.name || '-',
                        this.formatCPF(a.document_cpf) || '-',
                        a.financial_situation || '-',
                        a.registration_number || '-',
                        this.formatCurrency(a.previous_debts) || 'R$ 0,00'
                    ]);
                    break;

                case 'adimplentes':
                case 'ativos':
                case 'excluidos':
                case 'falecidos':
                    headers = ['Nome', 'CPF', 'Status Financeiro', 'Matrícula', 'Telefone'];
                    rows = (this.reportData.associados || []).map(a => [
                        a.name || '-',
                        this.formatCPF(a.document_cpf) || '-',
                        a.financial_situation || '-',
                        a.registration_number || '-',
                        this.formatPhone(a.phone_ddd, a.phone_number) || '-'
                    ]);
                    break;

                case 'inativos':
                    headers = ['Nome', 'CPF', 'Status Cadastro', 'Status Financeiro', 'Matrícula', 'Telefone'];
                    rows = (this.reportData.associados || []).map(a => [
                        a.name || '-',
                        this.formatCPF(a.document_cpf) || '-',
                        this.formatRegistrationStatus(a.registration_status),
                        a.financial_situation || '-',
                        a.registration_number || '-',
                        this.formatPhone(a.phone_ddd, a.phone_number) || '-'
                    ]);
                    break;

                case 'debitos-anteriores':
                    headers = ['Nome', 'CPF', 'Débitos Anteriores', 'Status', 'Última Atualização'];
                    rows = (this.reportData.associados || []).map(a => [
                        a.name || '-',
                        this.formatCPF(a.document_cpf) || '-',
                        this.formatCurrency(a.previous_debts) || 'R$ 0,00',
                        a.financial_situation || '-',
                        this.formatDate(a.last_updated_on) || '-'
                    ]);
                    break;

                case 'bonificacoes':
                    headers = ['Nome', 'Data', 'Valor', 'Tipo', 'Observações'];
                    rows = (this.reportData.pagamentos || []).map(p => [
                        p.user_name || '-',
                        this.formatDate(p.payment_date) || '-',
                        this.formatCurrency(p.bonus_discount) || 'R$ 0,00',
                        p.payment_type || '-',
                        p.comments || '-'
                    ]);
                    break;

                case 'pagamentos-periodo':
                    headers = ['Nome', 'Data', 'Meio', 'Tipo', 'Valor', 'Total'];
                    rows = (this.reportData.pagamentos || []).map(p => [
                        p.user_name || '-',
                        this.formatDate(p.payment_date) || '-',
                        p.payment_method || '-',
                        p.payment_type || '-',
                        this.formatCurrency(p.credit_value) || 'R$ 0,00',
                        this.formatCurrency(parseFloat(p.credit_value || 0) + parseFloat(p.membership_fee || 0) + parseFloat(p.charges || 0) + parseFloat(p.fees || 0)) || 'R$ 0,00'
                    ]);
                    break;

                case 'fluxo-caixa':
                    headers = ['Data', 'Descrição', 'Tipo', 'Entrada', 'Saída'];
                    rows = (this.reportData.cash_flows || []).map(cf => [
                        this.formatDate(cf.date) || '-',
                        cf.description || '-',
                        cf.type || '-',
                        cf.type === 'Entrada' ? this.formatCurrency(cf.value) : '-',
                        cf.type === 'Saída' ? this.formatCurrency(cf.value) : '-'
                    ]);
                    break;

                case 'parcelas-vencidas':
                    headers = ['Nome', 'CPF', 'Mês/Ano', 'Vencimento', 'Valor', 'Dias Vencido'];
                    rows = (this.reportData.parcelas || []).map(p => [
                        p.user_name || '-',
                        this.formatCPF(p.user_cpf) || '-',
                        `${String(p.month).padStart(2, '0')}/${p.year}`,
                        this.formatDate(p.due_date) || '-',
                        this.formatCurrency(p.amount) || 'R$ 0,00',
                        p.days_overdue || '0'
                    ]);
                    break;

                default:
                    headers = ['Total de Associados', 'Adimplentes', 'Inadimplentes', 'excluidos'];
                    rows = [[
                        this.reportData.total || '0',
                        this.reportData.adimplentes || '0',
                        this.reportData.inadimplentes || '0',
                        this.reportData.cancelados || '0'
                    ]];
            }

            return { headers, rows };
        },

        getReportTitle() {
            const titles = {
                'adimplentes': 'Relatório de Associados Adimplentes',
                'inadimplentes': 'Relatório de Associados Inadimplentes',
                'excluidos': 'Relatório de Associados Excluídos',
                'falecidos': 'Relatório de Associados Falecidos',
                'bonificacoes': 'Relatório de Bonificações e Descontos',
                'pagamentos-periodo': 'Relatório de Pagamentos por Período',
                'status-geral': 'Relatório de Status Financeiro Geral',
                'debitos-anteriores': 'Relatório de Débitos Anteriores',
                'ativos': 'Relatório de Associados Ativos',
                'inativos': 'Relatório de Associados Inativos (Excluídos + Falecidos)',
                'fluxo-caixa': 'Relatório de Fluxo de Caixa',
                'parcelas-vencidas': 'Relatório de Parcelas Vencidas',
            };
            return titles[this.selectedReport] || 'Relatório do Sistema';
        },

        formatCPF(cpf) {
            if (!cpf) return '';
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        },

        formatRegistrationStatus(status) {
            if (!status) return '-';
            if (status === 'Falecido') return 'Falecido';
            if (['Excluído', 'Cancelado', 'Cancelada'].includes(status)) return 'Excluído';
            return status;
        },

        formatPhone(ddd, number) {
            if (!ddd || !number) return '';
            return `(${ddd}) ${number}`;
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('pt-BR');
        },

        formatCurrency(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value || 0);
        },

        clearFilters() {
            const today = new Date();
            const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            this.filters = {
                initial_date: lastMonth.toISOString().split('T')[0],
                finish_date: today.toISOString().split('T')[0],
                payment_type: '',
                financial_situation: '',
                registration_status: '',
                min_value: '',
                max_value: '',
            };
            this.showPreview = false;
            this.reportData = null;
        },

        getFilteredCount() {
            if (!this.reportData) return 0;
            
            if (this.reportData.associados) return this.reportData.associados.length;
            if (this.reportData.pagamentos) return this.reportData.pagamentos.length;
            if (this.reportData.cash_flows) return this.reportData.cash_flows.length;
            if (this.reportData.parcelas) return this.reportData.parcelas.length;
            
            return this.reportData.total || 0;
        },
    },
    components: { Head, Button, Input, Select, Loader }
}
</script>

<template>
    <section class="reports-container">
        <Loader v-if="loader" />
        
        <Head title="Relatórios do Sistema" />

        <div class="header-section">
            <h2>📊 Relatórios do Sistema</h2>
            <p class="subtitle">Gere relatórios detalhados e exporte em PDF</p>
        </div>

        <div class="filters-section">
            <div class="filter-row">
                <Select 
                    label="Tipo de Relatório*" 
                    :options="reportTypes" 
                    :value="selectedReport" 
                    v-model="selectedReport"
                />
            </div>

            <div class="filter-row">
                <Input 
                    type="date" 
                    label="Data Inicial" 
                    :value="filters.initial_date" 
                    v-model="filters.initial_date"
                />
                <div class="filter-space"></div>
                <Input 
                    type="date" 
                    label="Data Final" 
                    :value="filters.finish_date" 
                    v-model="filters.finish_date"
                />
            </div>

            <div class="filter-row" v-if="['pagamentos-periodo', 'bonificacoes'].includes(selectedReport)">
                <Select 
                    label="Tipo de Pagamento" 
                    :options="paymentTypeOptions" 
                    :value="filters.payment_type" 
                    v-model="filters.payment_type"
                />
                <div class="filter-space"></div>
                <Input 
                    type="text" 
                    label="Valor Mínimo (R$)" 
                    placeholder="0.00"
                    :value="filters.min_value" 
                    v-model="filters.min_value"
                    :currencyMask="true"
                />
                <div class="filter-space"></div>
                <Input 
                    type="text" 
                    label="Valor Máximo (R$)" 
                    placeholder="0.00"
                    :value="filters.max_value" 
                    v-model="filters.max_value"
                    :currencyMask="true"
                />
            </div>

            <div class="filter-row" v-if="['status-geral', 'ativos', 'inativos'].includes(selectedReport)">
                <Select 
                    label="Status Financeiro" 
                    :options="financialSituationOptions" 
                    :value="filters.financial_situation" 
                    v-model="filters.financial_situation"
                />
                <div class="filter-space"></div>
                <Select 
                    label="Status de Cadastro" 
                    :options="registrationStatusOptions" 
                    :value="filters.registration_status" 
                    v-model="filters.registration_status"
                />
            </div>

            <div class="actions-row">
                <Button type="primary" placeholder="Gerar Relatório" @buttonPressed="generateReport" />
                <Button type="secondary" placeholder="Limpar Filtros" @buttonPressed="clearFilters" />
                <Button 
                    v-if="showPreview" 
                    type="success" 
                    placeholder="Exportar PDF" 
                    @buttonPressed="exportPDF" 
                />
            </div>
        </div>

        <div v-if="showPreview && reportData" class="preview-section">
            <div class="preview-header">
                <h3>📄 Prévia do Relatório</h3>
                <span class="badge">{{ getFilteredCount() }} registro(s) encontrado(s)</span>
            </div>

            <div class="preview-content">
                <p><strong>Tipo:</strong> {{ getReportTitle() }}</p>
                <p v-if="filters.initial_date && filters.finish_date">
                    <strong>Período:</strong> {{ formatDate(filters.initial_date) }} a {{ formatDate(filters.finish_date) }}
                </p>

                <div v-if="reportData.summary" class="summary-box">
                    <h4>📈 Resumo</h4>
                    <div class="summary-grid">
                        <div v-for="(value, key) in reportData.summary" :key="key" class="summary-item">
                            <span class="summary-label">{{ key }}:</span>
                            <span class="summary-value">{{ value }}</span>
                        </div>
                    </div>
                </div>

                <div class="preview-table">
                    <p class="table-info">💡 Os dados completos serão exportados no PDF. Clique em "Exportar PDF" acima.</p>
                </div>
            </div>
        </div>

        <div v-if="!showPreview" class="empty-state">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="empty-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>
            <h3>Nenhum relatório gerado</h3>
            <p>Selecione um tipo de relatório e clique em "Gerar Relatório"</p>
        </div>
    </section>
</template>

<style scoped>
.reports-container {
    padding: 20px;
    padding-bottom: 100px;
    max-width: 1400px;
    margin: 0 auto;
}

.header-section {
    background: white;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-section h2 {
    color: #333;
    margin-bottom: 10px;
}

.subtitle {
    color: #666;
    font-size: 14px;
    margin: 0;
}

.filters-section {
    background: white;
    padding: 25px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.filter-row {
    display: flex;
    gap: 15px;
    margin-bottom: 15px;
    align-items: flex-end;
}

.filter-space {
    width: 15px;
}

.actions-row {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
}

.preview-section {
    background: white;
    padding: 25px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 40px;
}

.preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #2196f3;
}

.preview-header h3 {
    margin: 0;
    color: #333;
}

.badge {
    background: #2196f3;
    color: white;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
}

.preview-content {
    margin-top: 20px;
}

.preview-content p {
    margin: 8px 0;
    color: #555;
    font-size: 14px;
}

.summary-box {
    margin: 20px 0;
    padding: 20px;
    background: #f8f9fa;
    border-left: 4px solid #2196f3;
    border-radius: 6px;
}

.summary-box h4 {
    margin: 0 0 15px 0;
    color: #333;
}

.summary-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 12px;
}

.summary-item {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: white;
    border-radius: 6px;
}

.summary-label {
    color: #666;
    font-size: 14px;
}

.summary-value {
    color: #333;
    font-weight: 600;
    font-size: 14px;
}

.preview-table {
    margin-top: 20px;
    padding: 20px;
    background: #e3f2fd;
    border-radius: 8px;
    border: 1px dashed #2196f3;
}

.table-info {
    margin: 0;
    color: #0d47a1;
    font-size: 14px;
    text-align: center;
}

.empty-state {
    background: white;
    padding: 60px 20px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 40px;
}

.empty-icon {
    width: 80px;
    height: 80px;
    color: #bbb;
    margin: 0 auto 20px;
}

.empty-state h3 {
    color: #333;
    margin: 0 0 10px 0;
}

.empty-state p {
    color: #666;
    margin: 0;
    font-size: 14px;
}
</style>
